import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsModel } from 'commons-vehicle/PurchaseMethods/index.js';

import AccessoriesListing from 'commons-vehicle/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx';
import AmountLineItemWithIcon from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx';
import DeliveryDetails from 'commons-vehicle/Quote/components/TransactionSummary/DeliveryDetails/DeliveryDetails.jsx';
import FinanceListing from 'commons-vehicle/Quote/components/TransactionSummary/FinanceListing/FinanceListing.jsx';
import ProtectionsListing from 'commons-vehicle/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx';

import 'commons-vehicle/Quote/components/TransactionSummary/Finance/Finance.scss';

const Finance = ({ purchaseMethods }) => {
    const purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    const purchaseMethodDeliveryAmounts = purchaseMethods.getSelectedPurchaseMethodDeliveryAmounts();
    const selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    const purchaseMethodLabels = purchaseMethods.getPurchaseMethodLabels(LocaleService);
    const paymentFrequencyLabels = purchaseMethods.getPaymentFrequencyLabels(false, LocaleService);
    const protectionsPackages = purchaseMethods.getSelectedProtectionsPackages();
    const accessoiresOptionsPackages = purchaseMethods.getSelectedOptions();

    const {
        discounts,
        exteriorColour,
        freightPDI,
        interiorColour,
        modelTrim,
        options,
        otherFees,
        protections,
        taxAndDuty,
    } = purchaseMethodAmounts;

    const allInPrice =
        modelTrim +
        exteriorColour +
        interiorColour +
        options +
        freightPDI +
        otherFees +
        taxAndDuty +
        protections -
        discounts;

    return (
        <div className="FinanceSummary">
            <div className="vehicle__salePrice">
                <AmountLineItemWithIcon
                    label={LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES')}
                    amount={allInPrice - protections}
                    icon="review"
                />
                <ProtectionsListing
                    purchaseMethodLabels={purchaseMethodLabels}
                    protectionsPackages={protectionsPackages}
                    purchaseMethods={purchaseMethods}
                />
            </div>

            <AccessoriesListing accessoriesOptions={accessoiresOptionsPackages} purchaseMethods={purchaseMethods} />

            <FinanceListing
                selectedFinanceTerm={selectedFinanceTerm}
                paymentFrequencyLabels={paymentFrequencyLabels}
                purchaseMethodLabels={purchaseMethodLabels}
                purchaseMethodAmounts={purchaseMethodAmounts}
            />

            <DeliveryDetails purchaseMethodDeliveryAmounts={purchaseMethodDeliveryAmounts} />
        </div>
    );
};

Finance.defaultProps = {};

Finance.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModel).isRequired,
};

Finance.displayName = 'Finance';

export default Finance;



// WEBPACK FOOTER //
// ./src/Quote/components/TransactionSummary/Finance/Finance.jsx